import { useCallback, useRef } from "react";

interface UseSoundOptions {
  volume?: number;
  loop?: boolean;
  onEnded?: () => void;
}

export const useSound = (soundUrl: string, options: UseSoundOptions = {}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const { volume = 1, loop = false, onEnded } = options;

  const play = useCallback(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(soundUrl);
      audioRef.current.volume = volume;
      audioRef.current.loop = loop;

      if (onEnded) {
        audioRef.current.addEventListener("ended", onEnded);
      }
    }

    // Сброс и воспроизведение
    audioRef.current.currentTime = 0;

    return audioRef.current.play().catch((error) => {
      console.error("Ошибка воспроизведения звука:", error);
    });
  }, [soundUrl, volume, loop, onEnded]);

  const pause = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  }, []);

  const stop = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, []);

  return { play, pause, stop };
};
